import { STRINGS } from "../utils/string";

import Modals from "./Modals/Modals";

export default function ContactsModals({
  mode,
  modalSize,
  additionalDetails,
  openModal,
  handleCloseModal,
  showFailureModal,
  handleFailure,
}) {
  return (
    <>
      <Modals
        modalMode={mode}
        modalSize={modalSize}
        additionalDetails={additionalDetails}
        open={openModal}
        onClose={handleCloseModal}
      />
      {showFailureModal && (
        <Modals
          modalMode={STRINGS.MODAL_MODE.FAILURE}
          modalSize={STRINGS.MODAL_SIZE.X_SMALL}
          additionalDetails={additionalDetails}
          open={true}
          onClose={handleFailure}
          disableBackdropClick={true}
          style={{ zIndex: 1400 }}
        />
      )}
    </>
  );
}
